import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class FinishedOrderNotificationSettings extends DataModel {
  static readonly TYPE_ID: string = 'a2f5f81cc5874b51ba1f08bf2ead56d5';

  constructor(
    public readonly enabled: boolean = false,
    public readonly title: string = '',
    public readonly body: string = '',
  ) {
    super();
  }

  get $typeId(): string {
    return FinishedOrderNotificationSettings.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FinishedOrderNotificationSettings {
    return new FinishedOrderNotificationSettings(
        MapUtils.get<boolean>(map, 'enabled'),
        MapUtils.get<string>(map, 'title'),
        MapUtils.get<string>(map, 'body'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'enabled': this.enabled,
      'title': this.title,
      'body': this.body,
    };
  }

  clone(): this {
    return new FinishedOrderNotificationSettings(
        this.enabled,
        this.title,
        this.body,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.enabled === this.enabled &&
        other.title === this.title &&
        other.body === this.body;
  }
}

export class FinishedOrderNotificationSettingsBuilder extends DataModelBuilder<FinishedOrderNotificationSettings> {
  build(context: SerializationContext, map: SerializedData): FinishedOrderNotificationSettings {
    return FinishedOrderNotificationSettings.fromMap(context, map);
  }
}
